<template>
  <!-- Status of a user's latest invite email in this workspace, with SendGrid's reason on hover (US 9365) -->
  <span class="v2-tag us-invite"
        :class="'us-invite--' + tone"
        v-b-tooltip.hover
        :title="tooltip"
        qid="users-invite-status"
  >
    <font-awesome-icon v-if="tone === 'red'" icon="exclamation-triangle"/>
    {{ $t('users_page.invite_status.' + status) }}
  </span>
</template>

<script>
  import {config} from '@/config.js';

  const TONES = {
    sent: 'grey',
    deferred: 'amber',
    delivered: 'blue',
    bounced: 'red',
    blocked: 'red',
    dropped: 'red',
    spam: 'red',
    none: 'outline'
  };

  export default {
    name: 'InviteStatus',
    props: {
      invite: Object
    },
    computed: {
      status() {
        return this.invite && TONES[this.invite.status] ? this.invite.status : 'none';
      },
      tone() {
        return TONES[this.status];
      },
      tooltip() {
        let lines = [];

        if (this.invite && this.invite.status_at) {
          lines.push(this.$t('users_page.invite_status.' + this.status) + ' · ' + this.$options.filters.formatDateTime(this.invite.status_at, config.dateFormat + ' HH:mm'));
        }
        lines.push(this.$t('users_page.invite_hint.' + this.status));
        if (this.invite && this.invite.status_reason && this.tone === 'red') {
          lines.push(this.invite.status_reason);
        }

        return lines.join(' – ');
      }
    }
  }
</script>
